/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react';

import './PublicKnowledgeSiteSetting.css';
import { Button, TextField } from '@material-ui/core';
import SettingLogoPublicSite from './SettingLogoPublicSite';
import {
    getError,
    getValue,
    onCopyURL,
    validateProjectAlias,
    validateHeader,
    validateFooter,
    generateURL,
    isDisableBtnSubmit,
    onClickBtnSave,
    saveInActiveUrl,
    onFocusOutProjectAlias
} from './handler/PublicKnowledgeSiteSettingHandler';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import Utils from '@/common/utils/utils';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { I18n } from 'aws-amplify';
import { useSnackbar } from 'notistack';
import LoadingPanel from '@/component/common/LoadingPanel';
import { getProjectById } from '@/service/projectService';
import localStorageUtil from '@/common/utils/localStorageUtil';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import OverFlowTooltipWithTabsMui from '../common/OverFlowTooltipWithTabsMui';
import { closeTabId, multiPanelAtom } from '@/state/atom/panelAtom';
import CancelTabsDialog from '../system/dialog/CancelTabsDialog';
import { closePanelTabSelector } from '@/state/selector/panelSelector';
import { updatePreviewSettingAtom } from '@/state/atom/chatBotPreview';
import { userAtom } from '@/state/atom/userAtom';
import { Storage } from 'aws-amplify';
import Constant from '../../common/constant/Constant';

const initDataSetting = {
    isActiveUrl: false,
    isShowKnowledgeList: true,
    isShowChatbot: true,
    isShowIframe: true,
    styleSheet: '',
    header: '',
    footer: '',
    gaScript: '',
    logo: '',
    projectAlias: ''
};

const BackToDefault = () => {
    return (
        <svg
            width="15"
            height="14"
            viewBox="0 0 15 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.07024 0.404628C8.50152 0.203255 9.95947 0.472493 11.2244 1.17177C12.4894 1.87106 13.4928 2.9625 14.0835 4.28165C14.6742 5.6008 14.8202 7.07621 14.4995 8.48555C14.1788 9.89489 13.4088 11.1618 12.3054 12.0955C11.202 13.0291 9.8251 13.5789 8.38212 13.6619C6.93913 13.745 5.50824 13.3568 4.30504 12.5559C3.10184 11.755 2.19151 10.5848 1.71122 9.22158C1.58887 8.87431 1.7712 8.49361 2.11847 8.37126C2.46574 8.24892 2.84644 8.43125 2.96878 8.77852C3.35302 9.86911 4.08128 10.8053 5.04384 11.446C6.0064 12.0867 7.15111 12.3972 8.3055 12.3308C9.45989 12.2644 10.5614 11.8245 11.4441 11.0776C12.3268 10.3307 12.9429 9.31717 13.1994 8.18969C13.456 7.06222 13.3392 5.8819 12.8666 4.82658C12.3941 3.77125 11.5913 2.8981 10.5794 2.33867C9.56739 1.77925 8.40102 1.56386 7.256 1.72496C6.11098 1.88606 5.04932 2.41492 4.23101 3.23185C4.22625 3.2366 4.22142 3.24128 4.21652 3.24588L2.3497 5.00005H4.66667C5.03486 5.00005 5.33333 5.29852 5.33333 5.66671C5.33333 6.0349 5.03486 6.33338 4.66667 6.33338H0.666667C0.298477 6.33338 0 6.0349 0 5.66671V1.66672C0 1.29853 0.298477 1.00005 0.666667 1.00005C1.03486 1.00005 1.33333 1.29853 1.33333 1.66672V4.12547L3.29632 2.28094C4.31823 1.26392 5.64237 0.60552 7.07024 0.404628Z"
                fill="#2D72D2"
            />
        </svg>
    );
};

export default function PublicKnowledgeSiteSetting(props) {
    const { enqueueSnackbar } = useSnackbar();

    const corporationDetail = useRecoilValue(corporationAtom);
    const [projectInuseDetail, setProjectInuseDetail] = useState({});
    const userDetail = useRecoilValue(userAtom);
    const [croppedImage, setCroppedImage] = useState(null);
    const [isEnableEditUrl, setIsEnableEditUrl] = useState(false);
    const [settingData, setSettingData] = useState({});
    const [errors, setErrors] = useState({});

    const [reloadPage, setReloadPage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isChangeData, setIsChangeData] = useState(false);
    const [isOpenConfirmSave, setIsOpenConfirmSave] = useState(false);
    const [isOpenConfirmReset, setIsOpenConfirmReset] = useState(false);
    const [previewSetting, setPreviewSetting] = useRecoilState(updatePreviewSettingAtom);

    const inputUrlRef = useRef();

    const [isConfirmCancelTabs, setIsConfirmCancelTabs] = useState(false);
    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);

    const panelList = useRecoilValue(multiPanelAtom);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);

    const [isShowDialogBacktoDefault, setIsShowDialogBacktoDefault] = useState(false);
    useEffect(() => {
        let isMounted = true;
        if(isMounted) initPageData();

        return () => {
            isMounted = false;
        }
    }, [reloadPage]);

    const initPageData = async () => {
        setErrors({});
        setIsChangeData(false);
        setIsEnableEditUrl(false);
        setCroppedImage(null);
        setIsLoading(true);

        let projectInuseId = localStorageUtil.getSelectedProjectId();
        let projectDetail = await getProjectById(props?.API, projectInuseId);
        setProjectInuseDetail(projectDetail);

        if (!Utils.isEmptyObject(projectDetail)) {
            let currentSettingData = projectDetail.publicKnowledgeSiteSetting;
            let initData = { ...initDataSetting };

            if (currentSettingData) {
                currentSettingData = Utils.convertJSONDataToObject(currentSettingData);
                let version = currentSettingData.versionPublicKnowledgeStyleCss;
                let fileKey = Constant.DEFAULT_PATH_STYLE_PUBLIC_KNOWLEDGE_SETTINGS;
                if (version > 1)// when create project versionPublicKnowledgeStyleCss of publicKnowledgeStyle setting = 1. It's default style
                    fileKey = Utils.genKeyFileCss(corporationDetail.id, projectDetail.id, version);

                let getFileResult = await Storage.get(fileKey, {
                    download: true,
                    cacheControl: 'no-cache'
                });
                let styleSheet = await new Response(getFileResult.Body).text();
                
                initData = {
                    isActiveUrl: currentSettingData.isActiveUrl,
                    isShowKnowledgeList: currentSettingData.isShowKnowledgeList,
                    isShowChatbot: currentSettingData.isShowChatbot,
                    isShowIframe: currentSettingData.isShowIframe,
                    styleSheet: styleSheet,
                    header: currentSettingData.header,
                    footer: currentSettingData.footer,
                    gaScript: currentSettingData.gaScript,
                    logo: currentSettingData.logo,
                    versionPublicKnowledgeStyleCss: version,
                    isEnableSearchSynonym: currentSettingData.isEnableSearchSynonym === false ? false : true
                };
            }
            initData.projectAlias = projectDetail.projectAlias
                ? projectDetail.projectAlias
                : projectDetail.id.replace('_', '-');

            setSettingData(initData);
            setPreviewSetting(prev => ({ ...prev, projectAlias: initData.projectAlias }));
        }

        setIsLoading(false);
    };

    const displaySearchSynonymSearchSetting = () => {
        const projectSetting =Utils.convertJSONDataToObject(projectInuseDetail.projectSetting);
        if(projectSetting.usingSynonym) return true;
        return false
    }

    useEffect(() => {
        if (props.tabId === closeTabIdState) {
            if (isChangeData) {
                setIsConfirmCancelTabs(true);
            } else {
                closePanelTab({
                    event: null,
                    panelType: props.panelType,
                    panelId: props.panelId,
                    tabId: props.tabId
                });
            }
            setCloseTabIdState(0);
        }
    }, [closeTabIdState]);

    const onChangeData = (event, fieldName) => {
        setIsChangeData(true);

        let settingDataClone = { ...settingData };
        let errorsClone = { ...errors };
        let currentValue = '';

        switch (fieldName) {
            case 'isActiveUrl':
                currentValue = settingDataClone.isActiveUrl;
                settingDataClone.isActiveUrl = !currentValue;
                break;
            case 'isShowKnowledgeList':
                currentValue = settingDataClone.isShowKnowledgeList;
                settingDataClone.isShowKnowledgeList = !currentValue;
                break;
            case 'isShowChatbot':
                currentValue = settingDataClone.isShowChatbot;
                settingDataClone.isShowChatbot = !currentValue;
                break;
            case 'isShowIframe':
                currentValue = settingDataClone.isShowIframe;
                settingDataClone.isShowIframe = !currentValue;
                break;
            case 'styleSheet':
                let newValueStyleSheet = event.target.value;
                settingDataClone.styleSheet = newValueStyleSheet;
                let errMsgStyleSheet = Utils.validateStyleSheet(newValueStyleSheet);
                if (Utils.isEmptyString(errMsgStyleSheet)) {
                    delete errorsClone.styleSheet;
                } else {
                    errorsClone.styleSheet = errMsgStyleSheet;
                }
                break;
            case 'header':
                let newValueHeader = event.target.value;
                settingDataClone.header = newValueHeader;
                let errMsgHeader = validateHeader(newValueHeader);
                if (Utils.isEmptyString(errMsgHeader)) {
                    delete errorsClone.header;
                } else {
                    errorsClone.header = errMsgHeader;
                }
                break;
            case 'gaScript':
                let errMsgGaScript = validateHeader(event.target.value);
                settingDataClone.gaScript = event.target.value;
                if (Utils.isEmptyString(errMsgGaScript)) {
                    delete errorsClone.gaScript;
                } else {
                    errorsClone.gaScript = errMsgGaScript;
                }
                break;
            case 'footer':
                let newValueFooter = event.target.value;
                settingDataClone.footer = newValueFooter;
                let errMsgFooter = validateFooter(newValueFooter);
                if (Utils.isEmptyString(errMsgFooter)) {
                    delete errorsClone.footer;
                } else {
                    errorsClone.footer = errMsgFooter;
                }
                break;
            case 'projectAlias':
                let newValue = event.target.value;

                if (/^[A-Za-z0-9-]*$/.test(newValue) === false) {
                    return;
                }

                settingDataClone.projectAlias = newValue;

                let errorMessage = validateProjectAlias(newValue);
                if (errorMessage) {
                    errorsClone.projectAlias = errorMessage;
                } else {
                    delete errorsClone.projectAlias;
                }

                break;
            case 'isEnableSearchSynonym' :
                currentValue = settingDataClone.isEnableSearchSynonym;
                settingDataClone.isEnableSearchSynonym = !currentValue;
                break

            default:
                break;
        }

        setSettingData(settingDataClone);
        setErrors(errorsClone);
    };

    const onHandleBacktoDefault = async () => {
        setIsShowDialogBacktoDefault(false);
        setIsChangeData(true);
        let fileKeyDefaultCss = Constant.DEFAULT_PATH_STYLE_PUBLIC_KNOWLEDGE_SETTINGS;
        setErrors(prev => {
            let prevClone = { ...prev };
            delete prevClone.styleSheet;
            return prevClone;
        });
        let getFileResult = await Storage.get(fileKeyDefaultCss, {
            download: true,
            cacheControl: 'no-cache'
        });
        let styleSheet = await new Response(getFileResult.Body).text();
        setSettingData(prev => ({
            ...prev,
            styleSheet: styleSheet
        }));
    };

    return (
        <div className="publicKnowledgeSiteSetting">
            <LoadingPanel isLoading={isLoading} />

            {!Utils.isEmptyObject(settingData) && (
                <>
                    <div className="groupBtn">
                        <Button
                            disabled={!isChangeData}
                            onClick={() => setIsOpenConfirmReset(true)}
                            variant="contained"
                            className="btn-hg32 btn-light"
                            color="primary"
                        >
                            キャンセル
                        </Button>

                        <Button
                            disabled={isDisableBtnSubmit(
                                isChangeData,
                                errors,
                                getValue(settingData, 'isActiveUrl')
                            )}
                            onClick={() =>
                                onClickBtnSave(
                                    props?.API,
                                    corporationDetail,
                                    projectInuseDetail,
                                    settingData,
                                    croppedImage,
                                    errors,
                                    setErrors,
                                    enqueueSnackbar,
                                    setIsLoading,
                                    setIsOpenConfirmSave,
                                    setReloadPage,
                                    userDetail.id
                                )
                            }
                            variant="contained"
                            className="btn-hg32 btn-primary"
                            color="primary"
                        >
                            保存
                        </Button>
                    </div>

                    <div className="groupSetting">
                        <h3 className="advanced-setting-title">{I18n.get('PLKNOWTT001')}</h3>
                        <div className="groupSettingContent">
                            <div className="groupSettingItem">
                                <label className="settingLable">{I18n.get('PLKNOWLB001')}</label>
                                <div className="switch-check">
                                    <input
                                        type="checkbox"
                                        id="isActiveUrl"
                                        // defaultChecked={getValue(settingData, 'isActiveUrl') ? true : false}
                                        checked={getValue(settingData, 'isActiveUrl') ? true : false}
                                    />
                                    <label
                                        htmlFor="isActiveUrl"
                                        onClick={e => onChangeData(e, 'isActiveUrl')}
                                    >
                                        <span className="switch-text"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    {settingData.isActiveUrl === true && (
                        <div className="groupSetting advanced-setting-group">
                            <div className="groupSettingContent">
                                <div className="groupSettingItem">
                                    <label className="settingLable">
                                        {I18n.get('PLKNOWLB002')}
                                    </label>
                                    <div className="switch-check">
                                        <input
                                            type="checkbox"
                                            id="isShowKnowledgeList"
                                            defaultChecked={getValue(settingData, 'isShowKnowledgeList')}
                                        />
                                        <label
                                            htmlFor="isShowKnowledgeList"
                                            onClick={e => onChangeData(e, 'isShowKnowledgeList')}
                                        >
                                            <span className="switch-text"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className="groupSettingContent">
                                <div className="groupSettingItem">
                                    <label className="settingLable">
                                        {I18n.get('PLKNOWLB003')}
                                    </label>
                                    <div className="switch-check">
                                        <input
                                            type="checkbox"
                                            id="isShowChatbot"
                                            defaultChecked={getValue(settingData, 'isShowChatbot')}
                                        />
                                        <label
                                            htmlFor="isShowChatbot"
                                            onClick={e => onChangeData(e, 'isShowChatbot')}
                                        >
                                            <span className="switch-text"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className="groupSettingContent">
                                <div className="groupSettingItem">
                                    <label className="settingLable">
                                        {I18n.get('PLKNOWLB004')}
                                    </label>
                                    <div className="switch-check">
                                        <input
                                            type="checkbox"
                                            id="isShowIframe"
                                            defaultChecked={getValue(settingData, 'isShowIframe')}
                                        />
                                        <label
                                            htmlFor="isShowIframe"
                                            onClick={e => onChangeData(e, 'isShowIframe')}
                                        >
                                            <span className="switch-text"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                          { displaySearchSynonymSearchSetting() && (<div className="groupSettingContent">
                                <div className="groupSettingItem">
                                    <label className="settingLable">
                                        {'類義語検索を使用する'}
                                    </label>
                                    <div className="switch-check">
                                        <input
                                            type="checkbox"
                                            id="isEnableSearchSynonym"
                                            defaultChecked={getValue(settingData, 'isEnableSearchSynonym') === false ? false : true}
                                        />
                                        <label
                                            htmlFor="isEnableSearchSynonym"
                                            onClick={e => onChangeData(e, 'isEnableSearchSynonym')}
                                        >
                                            <span className="switch-text"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>)}
                            <div className="groupSetting mb-10">
                                <h3 className="style-setting-title">{I18n.get('PLKNOWTT002')}</h3>

                                {/* setting style sheet */}
                                <div className="embeddedCode form-oversize">
                                    <div className="label-stylesheet">
                                        <div className="embeddedCode-label">
                                            {I18n.get('PLKNOWLB005')}{' '}
                                            <span className="required">*</span>
                                        </div>
                                        <Button
                                            startIcon={<BackToDefault />}
                                            onClick={() => setIsShowDialogBacktoDefault(true)}
                                            onKeyPress={e => e.preventDefault()}
                                        >
                                            {I18n.get('PLKNOWBT002')}
                                        </Button>
                                    </div>

                                    <TextField
                                        multiline
                                        fullWidth
                                        variant="outlined"
                                        name="styleSheet"
                                        value={getValue(settingData, 'styleSheet')}
                                        minRows={2}
                                        maxRows={2}
                                        onChange={e => onChangeData(e, 'styleSheet')}
                                        error={getError(errors, 'styleSheet') ? true : false}
                                        helperText={I18n.get(
                                            getError(errors, 'styleSheet')
                                        )?.replace('＜X＞', '200000')}
                                        placeholder={I18n.get('USER010PL001')}
                                    />
                                </div>

                                {/* setting header */}
                                <div className="embeddedCode form-oversize">
                                    <div className="embeddedCode-label">
                                        {I18n.get('PLKNOWLB006')}
                                    </div>
                                    <TextField
                                        multiline
                                        fullWidth
                                        variant="outlined"
                                        name="header"
                                        value={getValue(settingData, 'header')}
                                        minRows={2}
                                        maxRows={2}
                                        onChange={e => onChangeData(e, 'header')}
                                        error={getError(errors, 'header') ? true : false}
                                        helperText={I18n.get(getError(errors, 'header'))?.replace(
                                            '＜X＞',
                                            '20000'
                                        )}
                                        placeholder={I18n.get('USER010PL002')}
                                    />
                                </div>

                                {/* setting footer */}
                                <div className="embeddedCode form-oversize">
                                    <div className="embeddedCode-label">
                                        {I18n.get('PLKNOWLB007')}
                                    </div>
                                    <TextField
                                        multiline
                                        fullWidth
                                        variant="outlined"
                                        name="footer"
                                        value={getValue(settingData, 'footer')}
                                        minRows={2}
                                        maxRows={2}
                                        onChange={e => onChangeData(e, 'footer')}
                                        error={getError(errors, 'footer') ? true : false}
                                        helperText={I18n.get(getError(errors, 'footer'))?.replace(
                                            '＜X＞',
                                            '20000'
                                        )}
                                        placeholder={I18n.get('USER010PL003')}
                                    />
                                </div>
                                {/* GA config */}
                                <div className="embeddedCode form-oversize">
                                    <div className="embeddedCode-label">
                                        {I18n.get('PLKNOWLB029')}
                                    </div>
                                    <TextField
                                        multiline
                                        fullWidth
                                        variant="outlined"
                                        name="gaScript"
                                        value={getValue(settingData, 'gaScript')}
                                        minRows={2}
                                        maxRows={2}
                                        onChange={e => onChangeData(e, 'gaScript')}
                                        error={getError(errors, 'gaScript') ? true : false}
                                        helperText={I18n.get(getError(errors, 'gaScript'))?.replace(
                                            '＜X＞',
                                            '20000'
                                        )}
                                        placeholder={I18n.get('PLKNOWP006')}
                                    />
                                </div>

                                {/* setting logo */}
                                <SettingLogoPublicSite
                                    croppedImage={croppedImage}
                                    setCroppedImage={setCroppedImage}
                                    settingData={settingData}
                                    setSettingData={setSettingData}
                                    errors={errors}
                                    setErrors={setErrors}
                                    setIsChangeData={setIsChangeData}
                                    reloadPage={reloadPage}
                                />
                            </div>
                            <div className="groupSetting generateUrl">
                                <div className="generateUrl-group">
                                    <h3 className="generateUrl-title">{I18n.get('PLKNOWTT003')}</h3>

                                    {isEnableEditUrl ? (
                                        <div className="url-generated">
                                            <div className="url-text">
                                                <div className="url-part1">
                                                    <OverFlowTooltipWithTabsMui
                                                        value={`${window.location.origin}/${corporationDetail?.organizationDomain}/`}
                                                    />
                                                </div>

                                                <TextField
                                                    inputRef={inputUrlRef}
                                                    name="projectAlias"
                                                    className="input-projectAlias"
                                                    value={getValue(settingData, 'projectAlias')}
                                                    variant="outlined"
                                                    onChange={e => onChangeData(e, 'projectAlias')}
                                                    onBlur={e =>
                                                        onFocusOutProjectAlias(
                                                            e.target.value,
                                                            errors,
                                                            setErrors,
                                                            setIsEnableEditUrl
                                                        )
                                                    }
                                                    error={
                                                        getError(errors, 'projectAlias')
                                                            ? true
                                                            : false
                                                    }
                                                />
                                                <label>/kb</label>
                                            </div>
                                        </div>
                                    ) : (
                                        <a
                                            href={generateURL(
                                                corporationDetail?.organizationDomain,
                                                settingData?.projectAlias
                                            )}
                                            rel="noreferrer"
                                            target="_blank"
                                            style={{ wordBreak: 'break-all' }}
                                        >
                                            {generateURL(
                                                corporationDetail?.organizationDomain,
                                                settingData?.projectAlias
                                            )}
                                        </a>
                                    )}

                                    {getError(errors, 'projectAlias') ? (
                                        <div className="url-error">
                                            {I18n.get(getError(errors, 'projectAlias'))?.replace(
                                                '＜X＞',
                                                '120'
                                            )}
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                </div>

                                <div className="copyIframe">
                                    <Button
                                        className="buttonCopyIframe"
                                        onClick={() => {
                                            setIsEnableEditUrl(true);
                                            setTimeout(() => {
                                                inputUrlRef.current?.focus();
                                            }, 3);
                                        }}
                                    >
                                        <img
                                            src="/assets/image/edit-setting-public-url.svg"
                                            alt="Copy iframe"
                                        />
                                        {I18n.get('PLKNOWLB010')}
                                    </Button>

                                    <Button
                                        className="buttonCopyIframe"
                                        disabled={getError(errors, 'projectAlias') ? true : false}
                                        onClick={() =>
                                            onCopyURL(
                                                corporationDetail?.organizationDomain,
                                                settingData?.projectAlias
                                            )
                                        }
                                    >
                                        <img
                                            src="/assets/image/copy-iframe.svg"
                                            alt="Copy iframe"
                                        />
                                        {I18n.get('PLKNOWLB011')}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}

            {/* confirm save dialog: case inactive URL */}
            <ConfirmDialog
                isOpen={isOpenConfirmSave}
                msgConfirm={I18n.get('PLKNOWMSG005')}
                closeCallBack={() => {
                    setReloadPage(Date.now().toString());
                    setIsOpenConfirmSave(false);
                }}
                okCallBack={() => {
                    setIsOpenConfirmSave(false);
                    saveInActiveUrl(
                        props?.API,
                        projectInuseDetail,
                        settingData,
                        setIsLoading,
                        setReloadPage,
                        enqueueSnackbar,
                        userDetail.id
                    );
                }}
                textClose={I18n.get('COMBTN007')}
            />

            {/* confirm cancel dialog */}
            <ConfirmDialog
                isOpen={isOpenConfirmReset}
                msgConfirm={I18n.get('USER12MSG010')}
                closeCallBack={() => setIsOpenConfirmReset(false)}
                okCallBack={() => {
                    setReloadPage(Date.now().toString());
                    setIsOpenConfirmReset(false);
                }}
                textClose={I18n.get('COMBTN007')}
            />

            <CancelTabsDialog
                argsAll={{
                    isConfirmCancelTabs: isConfirmCancelTabs,
                    setIsConfirmCancelTabs: setIsConfirmCancelTabs,
                    closePanelTab: closePanelTab,
                    tabId: props.tabId,
                    panelId: props.panelId,
                    panelList: panelList
                }}
            />
            <ConfirmDialog
                isOpen={isShowDialogBacktoDefault}
                msgConfirm={I18n.get('PLKNOWMSG007')}
                closeCallBack={() => setIsShowDialogBacktoDefault(false)}
                okCallBack={async () => await onHandleBacktoDefault()}
                textClose={I18n.get('COMBTN007')}
            />
        </div>
    );
}
